"use client";

import { useState } from "react";

export type FaqItem = { q: string; a: string };

export function FaqAccordion({ items }: { items: FaqItem[] }) {
  const [open, setOpen] = useState<number | null>(0);

  return (
    <ul className="space-y-3">
      {items.map((item, i) => {
        const isOpen = open === i;
        return (
          <li
            key={item.q}
            className="rounded-2xl border border-white/10 bg-white/[0.03] overflow-hidden"
          >
            <button
              type="button"
              onClick={() => setOpen(isOpen ? null : i)}
              aria-expanded={isOpen}
              aria-controls={`faq-panel-${i}`}
              className="flex w-full items-center justify-between gap-4 px-6 py-5 text-left text-white transition hover:bg-white/[0.03] focus-visible:bg-white/[0.05]"
            >
              <span className="font-display text-base font-medium sm:text-lg">{item.q}</span>
              <span
                aria-hidden="true"
                className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full border border-white/20 text-mist transition ${isOpen ? "rotate-45" : ""}`}
              >
                +
              </span>
            </button>
            {isOpen && (
              <div
                id={`faq-panel-${i}`}
                role="region"
                className="border-t border-white/5 px-6 py-5 text-base leading-7 text-mist"
              >
                {item.a}
              </div>
            )}
          </li>
        );
      })}
    </ul>
  );
}
